
import React, { useState } from 'react';
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate } from 'react-router';
import flowchangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import { useAuthContext } from '../../../../Context/AuthContext';
import { useGlobalContext } from '../../../../Context/GlobalContext';
import Cookies from "js-cookie";
import { useLocation } from 'react-router';
import loginLady from "../../../../Assets/Images/login-lady.png";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const { baseUrl, openToast } = useGlobalContext();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const requestPassword = async () => {
    setIsLoading(true);
    try {
      if (password !== confirmPassword) {
        openToast("Please match the password and confirm password", "warning");
        return;
      }
      const result = await fetch(Cookies.get("baseUrl") + `admin/reset-password`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: Cookies.get("email"), password: password }),
      });

      const data = await result.json();
      if (!result.ok) {
        openToast(data?.message, "error");
      } else {
        openToast(data?.message, "success");
        Cookies.remove("email");
        Cookies.remove("baseUrl");
        navigate("/authentication/login");
      }
    } catch (error) {
      console.error("Error fetching project:", error);
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <div className='flex flex-col justify-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[10px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-lvh min-h-screen overflow-y-auto'>
      <div className='relative flex flex-start mt-9 ml-9'>
        <MdKeyboardArrowLeft className='top-3 left-4 absolute inset-y-0 mr-5 text-white' />
        <button className='bg-[#8a25b0] hover:bg-[#8a25b0]-400 px-9 py-2 rounded-full text-white' onClick={() => navigate("/authentication/login")}>
          Back
        </button>
      </div>
      <div className="flex justify-center bg-white m-auto rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div">
        <div className="space-y-2 sm:space-y-0 md:p-[30px] lg:px-[50px] xl:px-[30px] py-[22px] w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
          <div className="flex justify-center items-center">
            <img src={flowchangerLogo} alt="Flowchangers Logo" className='w-[120px]' />
          </div>
          <div className="">
            <p className="mt-[10px] pb-2 text-[#8c8c8c] text-[14px] text-center">Please Set Password </p>
            <form onSubmit={(e) => { e.preventDefault(); requestPassword(); }}>
              <div className="relative mb-6">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  aria-label="password"
                  className="login-input-field"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="top-[4px] right-[13px] absolute"
                >
                  {showPassword ? (
                    <VisibilityIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  ) : (
                    <VisibilityOffIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  )}
                </button>
              </div>
              <div className="relative mb-6">
                <input
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type={showPasswordConfirm ? "text" : "password"}
                  placeholder="Confirm your password"
                  aria-label="password"
                  className="login-input-field"
                />
                <button
                  type="button"
                  onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                  className="top-[4px] right-[13px] absolute"
                >
                  {showPasswordConfirm ? (
                    <VisibilityIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  ) : (
                    <VisibilityOffIcon className="top-[7px] right-[0px] absolute text-[#8a25b0] email-icon" />
                  )}
                </button>
              </div>
              <button
                type="submit"
                className={" font-medium text-[#fff] text-center free-signup  bg-[#8a25b0] w-full border-[#8a25b1]  rounded-full border py-[8px] px-4" + (isLoading && "disabled:animate-pulse disabled:cursor-not-allowed")
                }
              >
                Reset Password
              </button>
            </form>
          </div>
        </div>
        <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
              Very good works are waiting for you SignUp Now!!!
            </h2>
            <div className="top-[-6px] right-[-42px] bottom-0 absolute">
              <img src={loginLady} alt="loginLady" className="h-[100%]" />
            </div>
            <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ResetPassword;
